<h3 class="wf-peppol-detail-files__heading wf-text-sm-medium">
  {{ 'PEPPOL.Detail.FilesSection' | translate }}
</h3>

<wf-file-list
  [files]="entries()"
  [activeFileId]="activeFileName()"
  (view)="onView($event)"
  (download)="onDownload($event)"
/>
